import { useContext } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { AuthContext } from '../../context/AuthContext';

import { useNavigate } from 'react-router-dom';
import lunaImage from '../../assets/bg_image10_re1.jpg';
import tracker from '../../utils/tracker';

import './HomeSection.css';


const HomeSection = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);


  const handleGetStartedClick = () => {
    tracker.track('cta_click', { cta: 'home_get_started' });
    if (user) {
      navigate('/purchase');
    } else {
      navigate('/signup');
    }
  };



  return (
      <div className="home-container">
        <div className="text-section">
          <div className="number-cont"
          data-aos="fade-down"         
          data-aos-duration="550"    
          data-aos-delay="250"
          >
            <h1> THE FIRST CRYPTO FINDING APP IN THE WORLD</h1>
          </div>
          <p
          data-aos="fade-right"         
          data-aos-duration="700"    
          >Exploring the blockchain's forgotten corners.</p>
         
          <div className="button-wrapper1"
          data-aos="fade-right"         
          data-aos-duration="550"    
          data-aos-delay="600"
          >
            <button className="started-button" onClick={handleGetStartedClick}>
              Get Started <FaArrowRight className="button-arrow" />
            </button>
          </div>
        </div>

        <div className="image-section"
          data-aos="fade-up"         
          data-aos-duration="550"    
          data-aos-delay="0">
          <img draggable="false" src={lunaImage} alt="LunaSearch" />
        </div>
        <div className="divider"></div>
      </div>
  );
};

export default HomeSection;
